export function apply_form_behavior(selection, content_id) {
  let setup = false;
  window.addEventListener('message', (event) => {
    if (!(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady')) {
      return;
    }
    if (setup) {
      return;
    }
    setup = true;

    var reviewForm = document.querySelector(selection);
    if (!reviewForm) {
      return;
    }
    var contentIdElement = reviewForm.querySelector('[name="content_id"]');
    var contentParentElement = reviewForm.querySelector('.hs_content_id');

    // Set all fields' default value to blank
    reviewForm.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), textarea').forEach((field) => {
      field.value = '';
    });

    // Set the default value for content_id element and hide it
    contentIdElement.value = content_id;
    contentParentElement.style.display = 'none';
    jQuery(contentIdElement).removeOnce('sci');
    Drupal.attachBehaviors();

    // Do not allow reviewForm to be submitted if content_id is not available
    reviewForm.addEventListener('submit', (event) => {
      if (!contentIdElement.value) {
        event.preventDefault();
        alert('Product is not available. Form cannot be submitted.');
        return false;
      }
    });
  });
}
